import React from 'react'
import { Box, Divider, Stack, Typography } from '@mui/material'
import ActivityReportMapLegend from './ActivityReportMapLegend'
import { ACTIVITY_REPORT_MAP_COLORS, ACTIVITY_REPORT_MAP_TEXT } from './constants'

export default function ReportMapSection({
  title = ACTIVITY_REPORT_MAP_TEXT.mapSectionTitle,
  subtitle = ACTIVITY_REPORT_MAP_TEXT.mapSectionSubtitle,
  legendItems = [],
  canvasId = 'map-canvas',
  children
}) {
  return (
    <Box
      className="activity-report-map-section"
      component="section"
      sx={{
        borderRadius: 3,
        border: `1px solid ${ACTIVITY_REPORT_MAP_COLORS.desktopCardBorder}`,
        overflow: 'hidden',
        bgcolor: ACTIVITY_REPORT_MAP_COLORS.white
      }}
    >
      <Box
        sx={{
          px: { xs: 2, md: 2.5 },
          py: 1.75
        }}
      >
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          spacing={1.5}
          alignItems={{ xs: 'flex-start', md: 'center' }}
          justifyContent="space-between"
        >
          <Box>
            <Typography
              sx={{
                color: ACTIVITY_REPORT_MAP_COLORS.desktopSectionTitle,
                fontSize: 18,
                fontWeight: 700
              }}
            >
              {title}
            </Typography>
            <Typography
              sx={{
                mt: 0.25,
                color: ACTIVITY_REPORT_MAP_COLORS.desktopSectionSubtitle,
                fontSize: 13
              }}
            >
              {subtitle}
            </Typography>
          </Box>

          <ActivityReportMapLegend items={legendItems} />
        </Stack>
      </Box>

      <Divider />

      <Box sx={{ p: { xs: 1.5, md: 2 } }}>
        <div id={canvasId}>{children}</div>
      </Box>
    </Box>
  )
}
